import {
  STRUCTURAL_RESPONSES,
  COMPONENT_POPULATION,
} from '@hbrisk/sp3-risk-model-support/models/app/attributes/names/index.js';
import makeFormMiddleware from '#middlewares/support/makeFormMiddlware.js';
import { modelTypes } from '#constants/models/modelTypes/index.js';
import { putModel } from '#actions/models/model.js';
import calculateModelPutPayload from '#support/models/calculateModelPutPayload.js';
import { currentModelId } from '#selectors/entities/models.js';
import geocodeOnAddressChange from '#middlewares/modelForm/geocodeOnAddressChange.js';
import validateOnFetchResponse from '#middlewares/modelForm/validateOnFetchResponse.js';
import updateStructuralResponsesOnBuildingTypeChange from '#middlewares/modelForm/updateStructuralResponsesOnBuildingTypeChange.js';
import updateReponseItemKeyReferencesOnDeletedResponse from '#middlewares/modelForm/updateReponseItemKeyReferencesOnDeletedResponse.js';

const modelFormMiddlewares = modelTypes.map(modelType => {
  const { modelFormName, fields, fieldsByName } = modelType;
  return makeFormMiddleware({
    form: modelFormName,
    fields,
    selectCurrentUuid: currentModelId,
    saveActionCreator: putModel,
    calculatePayload: calculateModelPutPayload,
    extensions: [
      validateOnFetchResponse,
      geocodeOnAddressChange,
      ...(fieldsByName[STRUCTURAL_RESPONSES]
        ? [updateStructuralResponsesOnBuildingTypeChange]
        : []),
      ...(fieldsByName[COMPONENT_POPULATION]
        ? [updateReponseItemKeyReferencesOnDeletedResponse]
        : []),
    ],
  });
});

export default modelFormMiddlewares;
